module.exports = __webpack_public_path__ + "assets/img/juqu_content_1.f6de316c.png";